import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../../components/Modal';
import { fetchUsuariosAprobadores, autorizarActividad } from '../../../../actions';

const AprobacionAutorizacion = props => (
  <Modal title='Aprobar Autorización' idModal='fdv-aprobacion' isOpen={props.isOpen} closeModal={props.closeModal} modalSize='modal-sm little-modal modal-margin-top'>
    <p className='mt-2 mb-2'>¿Desea aprobar el pedido {props.numPedidoVeh}?</p>
    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.closeModal}>Cancelar</button>
      <button className='btn btn-primary pull-right' onClick={props.aprobarAutorizacion}>Aceptar</button>
    </div>
  </Modal>
);

class AprobadoresValidacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
      usuariosAprobadores: [],
      nameModalValue:'',
      isOpen:false
    };
  }

  hoverOn = () => {
    this.setState({
      hover: true
    });
    this.getAprobadores();
  }

  hoverOff = () => {
    this.setState({
      hover: false,
      usuariosAprobadores: []
    });
  }

  openModal = (nameModal,props) =>{
    if(nameModal === 'aprobar-autorizacion'){
      this.setState({
          nameModalValue:nameModal,
          isOpen:true,
        });
    }
  }

  closeModal = () =>{
    this.setState({
      isOpen:false
    });
  }

  getAprobadores = () => {
    this.props.fetchUsuariosAprobadores(
      this.props.detalleAutorizacion.numFichaVtaVeh,
      this.props.detalleAutorizacion.codCia,
      this.props.detalleAutorizacion.codProvee,
      this.props.detalleAutorizacion.numPedidoVeh,
      this.props.detalleAutorizacion.codAutFichaVta).then((result) => {
        if (result.payload.data.estadoTrama === '1') {
          const listadoAprobadores = result.payload.data.usuarioAutorizadorList;
          this.setState({
            usuariosAprobadores:listadoAprobadores
          });
        }
      }).catch(error => console.log(error));
  }

  AprobarAutorizacion = () => {
    autorizarActividad(
      this.props.detalleAutorizacion.numFichaVtaVeh,
      this.props.detalleAutorizacion.codAutFichaVta,
      this.props.detalleAutorizacion.codCia,
      this.props.detalleAutorizacion.codProvee,
      this.props.detalleAutorizacion.numPedidoVeh).then((result) => {
        const response = result.data;
        this.props.openAlert(response);
        this.closeModal();
        this.props.changeIndex(6);
      });
  }

  render() {
    return(
            <div>
              {
                this.state.nameModalValue === 'aprobar-autorizacion' &&
                  <AprobacionAutorizacion
                    isOpen={this.state.isOpen}
                    closeModal={this.closeModal}
                    aprobarAutorizacion={this.AprobarAutorizacion}
                    numPedidoVeh={this.props.detalleAutorizacion.numPedidoVeh}
                  />
              }
              <div className='checkbox checkbox-inline'>
                <label>
                  <input type='checkbox'
                    disabled={this.props.detalleAutorizacion.indAutoriza==='N'}
                    onClick={() => this.openModal('aprobar-autorizacion',this.props)}/>
                  <div className='checkbox-skin' />
                </label>
              </div>
              <a>
                <i className='ion-person-stalker c-gray-1 ml-2'
                   onMouseEnter={this.hoverOn}
                   onMouseLeave={this.hoverOff}>
                </i>
                {
                  this.state.hover ?
                    <span className='tooltip-down'>Aprobadores:
                      {
                        this.state.usuariosAprobadores.map((aprobador, id) =>
                          <div key={id}>{aprobador.nomUsuaAuto}</div>
                        )
                      }
                    </span>
                  : null
                }
              </a>
            </div>
          );
  }
}

function mapStateToProps(state) {
  return {
    usuariosAprobadores: state.usuariosAprobadores
  };
}

AprobadoresValidacion.defaultProps = {
  usuariosAprobadores: []
};

export default connect(mapStateToProps,
{
  fetchUsuariosAprobadores
})(AprobadoresValidacion);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/components/AprobadoresValidacion.js